"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var AddAttributeFilterButton_1 = require("./AddAttributeFilterButton");
var model_1 = require("../../../../model");
var tooltipAlignPoints = [
    { align: "cr cl", offset: { x: 10, y: 0 } },
    { align: "cl cr", offset: { x: -10, y: 0 } },
];
var dropdownAlignPoints = [
    {
        align: "bl tl",
    },
    {
        align: "tr tl",
    },
    {
        align: "tr tl",
        offset: {
            x: 0,
            y: -100,
        },
    },
    {
        align: "tr tl",
        offset: {
            x: 0,
            y: -50,
        },
    },
    {
        align: "br tr",
        offset: {
            x: -10,
            y: 0,
        },
    },
    {
        align: "tl tr",
        offset: {
            x: 0,
            y: -100,
        },
    },
    {
        align: "tl tr",
        offset: {
            x: 0,
            y: -50,
        },
    },
];
function AttributeListItem(_a) {
    var item = _a.item, isMobile = _a.isMobile, onClick = _a.onClick;
    if (!item) {
        return null;
    }
    var metricItemClassNames = classnames_1.default("s-" + util_1.stringUtils.simplifyText(item.attribute.title), {
        "gd-list-item": true,
        "gd-list-item-shortened": true,
    });
    var title = isMobile ? (item.attribute.title) : (react_1.default.createElement(sdk_ui_kit_1.ShortenedText, { tooltipAlignPoints: tooltipAlignPoints }, item.attribute.title));
    return (react_1.default.createElement("div", { key: item.attribute.id, className: metricItemClassNames, onClick: onClick }, title));
}
/**
 * @internal
 */
function AttributesDropdown(_a) {
    var className = _a.className, bodyClassName = _a.bodyClassName, onClose = _a.onClose, onSelect = _a.onSelect;
    var intl = react_intl_1.useIntl();
    var _b = tslib_1.__read(react_1.useState(""), 2), searchQuery = _b[0], setSearchQuery = _b[1];
    var _c = tslib_1.__read(react_1.useState(false), 2), closeOnParentScroll = _c[0], setCloseOnParentScroll = _c[1];
    // 1) Dragging this component into FilterBar could change height of FilterBar (FilterBar is sticky)
    // 2) When size of sticky element changed, then scroll position of dashboard is changed
    // 3) Then onScroll event is fired (By default window scroll event)
    // 4) KD or external app onScroll could fire "goodstrap.scrolled" custom event to close all opened overlays that have closeOnParentScroll = true
    // 5) Result is when this component change height of FilterBar it will be immediately closed after user drop it into FilterBar
    // 6) To prevent this behavior we initialize this component with closeOnParentScroll = false
    // 7) And in timeout 0.5 we set closeOnParentScroll = true to keep behavior that dropdown is closed when user scroll
    react_1.useEffect(function () {
        var timer = window.setTimeout(function () { return setCloseOnParentScroll(true); }, 500);
        return function () {
            if (timer !== null) {
                window.clearTimeout(timer);
            }
        };
    }, []);
    var attributes = model_1.useDashboardSelector(model_1.selectCatalogAttributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var onSearch = react_1.useCallback(debounce_1.default(function (query) {
        setSearchQuery(query);
    }, 250), []);
    var onDropdownStateChange = react_1.useCallback(function (isOpen) {
        if (!isOpen) {
            onClose();
        }
    }, [onClose]);
    var dropdownClassName = classnames_1.default(className, "s-attribute_select", "attribute-filter-dropdown", "add-attribute-filter-dropdown");
    var filteredMeasures = searchQuery
        ? attributes.filter(function (a) { return a.attribute.title.toLowerCase().includes(searchQuery.toLowerCase()); })
        : attributes;
    return (react_1.default.createElement(sdk_ui_kit_1.Dropdown, { className: dropdownClassName, onOpenStateChanged: onDropdownStateChange, closeOnParentScroll: closeOnParentScroll, closeOnMouseDrag: true, closeOnOutsideClick: true, alignPoints: dropdownAlignPoints, openOnInit: true, renderButton: function (_a) {
            var isOpen = _a.isOpen;
            return (react_1.default.createElement(AddAttributeFilterButton_1.AddAttributeFilterButton, { className: "attribute-filter-button mobile-dropdown-button", isOpen: isOpen }));
        }, renderBody: function (_a) {
            var closeDropdown = _a.closeDropdown;
            return (react_1.default.createElement("div", { className: classnames_1.default(bodyClassName, "attributes-list") },
                react_1.default.createElement(sdk_ui_kit_1.DropdownList, { items: filteredMeasures, searchFieldSize: "small", showSearch: true, onSearch: onSearch, searchString: searchQuery, searchPlaceholder: intl.formatMessage({
                        id: "attributesDropdown.placeholder",
                    }), renderItem: function (_a) {
                        var item = _a.item;
                        return (react_1.default.createElement(AttributeListItem, { item: item, onClick: function () {
                                onSelect(item.defaultDisplayForm.ref);
                                closeDropdown();
                            } }));
                    } })));
        } }));
}
exports.AttributesDropdown = AttributesDropdown;
//# sourceMappingURL=AttributesDropdown.js.map